import styled from "styled-components";
import { palette, font } from "styled-theme";

const DashAppHolder = styled.div`
  font-family: ${font("primary", 0)};

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  a,
  p,
  li,
  input,
  textarea,
  span,
  div,
  img,
  svg {
    &::selection {
      background: ${palette("primary", 0)};
      color: #fff;
    }
  }

  p {
    margin-bottom:4px !important;
    white-space:pre-wrap;
  }

  label {
    margin-bottom:5px;
  }
  .ant-form-item {
    margin-bottom: 5px;
  }
  .ant-form-item-label {
    margin-top:10px;
    line-height:12px;
  }

  .ant-list-item:hover {
    background: #f7f8f9;
  }

  .ant-list.no-hover .ant-list-item:hover {
    background: transparent;
  }

  .ant-row {
    ${"" /* margin-left: -8px;
    margin-right: -8px; */};
  }

  .ant-row > div {
    padding: 0;
  }

  .row-vertical-padding > .ant-col {
    padding-bottom: 12px;
  }

  .icon-container {
    display: inline;
    padding: 0 15px;

    svg {
      cursor: pointer;
    }
  }

  .isoLeftRightComponent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .isoCenterComponent {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .areaTitle {
    font-size: 1.5em;
    text-transform: uppercase;
    margin-bottom: 20px;

    .areaTitleIcon {
      display: inline-block;
      margin-right: 10px;
    }
  }

  .sub-title {
    font-size: 1.2em;
    font-weight: 400;
  }

  .action-icon {
    cursor: pointer;
    display: inline;
  }

  .dnd-handle {
    cursor: grab;

    .action-icon {
      padding: 0 15px;
      display: none;
    }
  }

  .dnd-handle:hover {
    .action-icon {
      display: inline;
    }
  }

  .icon-handle {
    cursor: default;

    .action-icon {
      padding: 0 15px;
      display: none;
    }
  }

  .icon-handle:hover {
    .action-icon {
      display: inline;
    }
  }

  .text-right {
    text-align: right;
  }

  .toggleButton {
    margin-right: -50px;
    float: right;
  }

  .filter-label {
    margin-right: 5px;
  }

  .horizontal-timeline {
    width: 90%;
    height: 60px;
    float: left;

    ol.events-bar {
      li.dot-label {
        bottom: -45px !important;

        span {
          bottom: 40px !important;
        }
      }
    }

    .events-wrapper .events {
      top: 30px !important;
    }

    .button-back,
    .button-forward {
      height: 25px !important;
      width: 25px !important;
      top: 30px !important;

      svg {
        width: 20px !important;
      }
    }
  }

  .ant-card-bordered {
    border-color: #a9a9a9;
    .ant-card-head {
      border-color: #a9a9a9;
    }
  }
  .isoBoxWrapper {
    border-color: #d6d6d6;
  }
  .ant-btn-default {
    border-color: #c3c3c3;
  }

  .edit-cycles-container {
    max-height: 600px;
    overflow-y: auto;
    overflow-x: hidden;
    margin-bottom: 30px;
    border: 1px solid #717171;

    .ant-list-split .ant-list-item {
      border-color: #717171;
    }

    .ant-list-item.ant-list-item-no-flex > .ant-row-flex {
      padding: 0 10px;
    }
  }

  .compact-form-items .ant-form-item-control {
    line-height: 26px;
  }

  .UserAvatar--dark {
    color: white !important;
  }
  .UserAvatar--light {
    color: black !important;
  }

  pre {
    background-color: unset;
    border: none;
  }



  .treatment-info-slider {
    margin-bottom: 5px;
    margin-top: -10px;
    .slick-dots {
      bottom: -15px;
      line-height: 12px;
    }
  }

  .treatement-status {
    width: 16px;
    height: 16px;
    display: inline-block;
    text-align: center;
    margin-right: 5px;
  }
  .treatement-status: hover {
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);
    border-radius: 5px;
  }

  .ant-tooltip-inner {
    pre {
      background-color: unset;
      border: unset;
      color: #fff;
    }
  }

  .disabled {
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
  }

  .comma-separated-components:after {
    content: ", ";
  }
  .comma-separated-components:last-child:after {
    content: "";
  }

  .timelineAvatar {
    margin-top: 20px;
    margin-left: 20px;
    margin-bottom: 10px;
  }

  .timelineText {
    margin-left: 15px;
    margin-top: 5px;
  }

  .vitalTimelineTextMultiline {
    margin-left: 10px;

  }

`;

export default DashAppHolder;
